import MyContainer from "@/components/MyContainer";
import DeliveryFeeForm from "@/pages/delivery-fee/form/delivery-fee-form";
import { useGetDeliveryFee } from "@/services/delivery-fee-service";
import { Box } from "@mui/material";
import { useParams } from "wouter";

export function EditDeliveryFee() {
  const params = useParams();
  const deliveryFeeId = params.id?.toString();

  if (!deliveryFeeId) {
    return (
      <MyContainer title="Edit Delivery Fee" subtitle="Edit delivery fee">
        <div>Delivery fee not found</div>
      </MyContainer>
    );
  }

  const { data: initialValues, isLoading } = useGetDeliveryFee(deliveryFeeId);

  if (isLoading) {
    return (
      <MyContainer title="Edit Delivery Fee" subtitle="Edit delivery fee">
        <Box sx={{ p: 2, color: "text.secondary" }}>Loading…</Box>
      </MyContainer>
    );
  }

  if (!initialValues) {
    return (
      <MyContainer title="Edit Delivery Fee" subtitle="Edit delivery fee">
        <Box sx={{ p: 2, color: "text.secondary" }}>Delivery fee not found</Box>
      </MyContainer>
    );
  }

  return (
    <MyContainer title="Edit Delivery Fee" subtitle="Edit delivery fee">
      <DeliveryFeeForm mode="update" initialValues={initialValues} />
    </MyContainer>
  );
}
